import { render } from "./index.vue?vue&type=template&id=c48b8060"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c48b8060&lang=less"

import exportComponent from "/Users/xiaobiaoza/Desktop/workspace/GIM/WPP/wpp-aigc-aigc-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/frame/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c48b8060"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c48b8060', __exports__)) {
    console.log('reload')
    api.reload('c48b8060', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=c48b8060", () => {
    console.log('re-render')
    api.rerender('c48b8060', render)
  })

}


export default __exports__